/*
 * Public API Surface of pdf-viewer
 */

export * from './lib/components/pdf-viewer.component';
export * from './lib/dialogs/pdf-viewer-dialog/pdf-viewer-dialog.component';
export * from './lib/pdf-viewer.providers';
